export const RESET_USER = "RESET_USER"
export const SET_USER = "SET_USER"
export const SET_SIDEBAR = "SET_SIDEBAR"
export const SET_SIDEBAR_FOLDABLE = "SET_SIDEBAR_FOLDABLE"
export const SET_LIST_USER_PHOTO = "SET_LIST_USER_PHOTO"
